import { useState, useCallback } from 'react';
import axios from 'axios';

export const useWallet = () => {
    const [availableBalance, setAvailableBalance] = useState(0);
    const [availableCompany, setAvailableCompany] = useState(0);
    const [availableSelf, setAvailableSelf] = useState(0);
    const [availableCashback, setAvailableCashback] = useState(0);

    const getAuthVars = () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        return { userId, token };
    };

    const fetchWalletData = useCallback(async () => {
        const { userId, token } = getAuthVars();
        if (!userId || !token) return;
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const data = response.data || {};
            setAvailableBalance(data.totalBalance || 0);
            setAvailableCompany(data.companyLoadedAmount || 0);
            setAvailableSelf(data.selfLoadedAmount || 0);
            setAvailableCashback(data.cashbackAmount || 0);
        } catch (error) {
            console.error("Wallet API Error:", error);
        }
    }, []);

    return {
        availableBalance,
        availableCompany,
        availableSelf,
        availableCashback,
        fetchWalletData
    };
};